export const ueepci_item = [
    {
        "nombre": "Informe UEEPCI 2022",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                // "nombre": "Las personas físicas y morales interesadas.",
                // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                // "html": "./Transparencia/htm/a69_f13_SC.htm"
            }
        ],
             "url" : "/interes/Informe UEEPCI 2022.pdf"
    },
        {
        "nombre": "Informe UEEPCI 2023",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                // "nombre": "Las personas físicas y morales interesadas.",
                // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                // "html": "./Transparencia/htm/a69_f13_SC.htm"
            }
        ],
         "url" : "/interes/Informe UEEPCI 2023.pdf"
        },

        {
          "nombre": "Informe UEEPCI 2024",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Informe UEEPCI 2024.pdf"
         },

          {
          "nombre": "Informe UEEPCI 2025",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/FORMATO_2025.xlsx"
         },


        {
          "nombre": "DGV 241 CS 2025",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/DGV_241_CS_2025.pdf"
         },
         {
          "nombre": "Manifiesto Servidores Públicos",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Manifiesto_PSP.pdf"
         },
         {
          "nombre": "Manifiesto Personas Públicas",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Manifiesto_PP.pdf"
         },

         {
          "nombre": "FORMATO DE REGISTRO DE DENUNCIAS ANTE EL CEPCI",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/FORMATO_REGISTRO.xlsx"
         },

        
	
];